<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.81145 16.71581">
		<path d="M12.81144 6.40673a.75.75 0 0 1-1.28028.53027L6.4047 1.81055 1.27823 6.937A.74992.74992 0 0 1 .21769 5.87646L5.87441.21973l.00028-.00028a.74972.74972 0 0 1 1.06027.00028l5.65675 5.65673a.74756.74756 0 0 1 .21973.53028Z"/>
		<path d="M6.3891 16.71581a.75.75 0 0 1-.75-.75v-14.5a.75.75 0 0 1 .75-.75.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-.75.75Z"/>
	</svg>
</template>
